import { z } from 'zod';

import {
    createDeleteSchema,
    createUpdateSchemaFromAdd,
    requiredNumber,
    requiredUuid,
} from './fields';
import { SYNC_UPDATE_VALIDATION_SCHEMA } from './common';

export const createHorseContactsAddSchema = () =>
    z.object({
        id: requiredUuid(),
        created_at: requiredNumber(),
        updated_at: requiredNumber(),
        horse_id: requiredUuid(),
        contact_id: requiredUuid(),
        user_id: requiredUuid(),
        organisation_id: requiredUuid(),
    });

export const createHorseContactsUpdateSchema = () =>
    createUpdateSchemaFromAdd(
        createHorseContactsAddSchema(),
        SYNC_UPDATE_VALIDATION_SCHEMA.horse_contacts,
    );

export const createHorseContactsDeleteSchema = () => createDeleteSchema();

export const createHorseContactsSchemas = () => ({
    add: createHorseContactsAddSchema(),
    update: createHorseContactsUpdateSchema(),
    delete: createHorseContactsDeleteSchema(),
});
